<ng-container *ngIf="isShowContent">
  <np-pin-twillio-authy [buttonName]="btnName" (submitted)="reactivateAccount($event)"
    (onetouchApproved)="reactivateAccount()" (sendCode)="sendCode($event)" [pinCodeError]="pinCodeError"
    [ticketType]="ticketType" [token]="tokenHash" [email]="email" (exceedInvalidCode)="exceedInvalidCode()"
    [sendOnetouchSuccess]="sendOnetouchSuccess"></np-pin-twillio-authy>
</ng-container>